import React, { useState } from 'react';

// 页面模板：普通列表页
// 使用方式：
// 1. 复制本文件并改名，例如 AwardListPage.js。
// 2. 修改 MOCK_DATA、筛选字段、表头和表格行。
// 3. 在 App.js 增加 Route，在 Sidebar.js 增加菜单。

// ================= 页面数据 =================
// 真实页面可以改成从 src/data/mockData.js 导入。
const MOCK_DATA = [
  {
    id: 1,
    name: '示例事项一',
    type: '德育素质',
    status: '启用',
    owner: '校级',
  },
  {
    id: 2,
    name: '示例事项二',
    type: '智育素质',
    status: '禁用',
    owner: '学院',
  },
];

export default function TemplatePage() {
  // ================= 页面状态 =================
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('');

  // ================= 查询逻辑 =================
  const filteredData = MOCK_DATA.filter(item => {
    if (keyword && !item.name.includes(keyword)) return false;
    if (status && item.status !== status) return false;
    return true;
  });

  // ================= 事件处理 =================
  const handleReset = () => {
    setKeyword('');
    setStatus('');
  };

  return (
    <div className="space-y-4">
      {/* 条件筛选卡片：新增筛选项时，复制一个 flex items-center 块 */}
      <div className="bg-white rounded shadow-sm border border-slate-200 p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* 筛选项：名称 */}
          <div className="flex items-center gap-2">
            <span className="text-sm text-slate-700 w-24 text-right shrink-0 whitespace-nowrap">
              名称：
            </span>
            <input
              value={keyword}
              onChange={event => setKeyword(event.target.value)}
              type="text"
              placeholder="请输入名称"
              className="border border-slate-300 rounded px-3 py-1.5 text-sm flex-1 min-w-0 outline-none"
            />
          </div>

          {/* 筛选项：状态 */}
          <div className="flex items-center gap-2">
            <span className="text-sm text-slate-700 w-24 text-right shrink-0 whitespace-nowrap">
              状态：
            </span>
            <select
              value={status}
              onChange={event => setStatus(event.target.value)}
              className="border border-slate-300 rounded px-3 py-1.5 text-sm flex-1 min-w-0 outline-none bg-white"
            >
              <option value="">全部</option>
              <option value="启用">启用</option>
              <option value="禁用">禁用</option>
            </select>
          </div>
        </div>

        {/* 查询按钮区 */}
        <div className="flex justify-end mt-4 pt-4 border-t border-slate-100 gap-2">
          <button
            onClick={handleReset}
            className="px-6 py-1.5 border border-slate-300 rounded text-sm hover:bg-slate-50 transition-colors"
          >
            重置
          </button>
          <button className="px-6 py-1.5 bg-blue-500 text-white rounded text-sm hover:bg-blue-600 shadow-sm transition-colors">
            查询
          </button>
        </div>
      </div>

      {/* 结果卡片：按钮、提示、表格一般放在这里 */}
      <div className="bg-white rounded shadow-sm border border-slate-200 p-4">
        {/* 表格上方操作按钮区 */}
        <div className="mb-4 flex gap-2">
          <button className="px-4 py-1.5 bg-blue-500 text-white rounded text-sm hover:bg-blue-600 shadow-sm transition-colors">
            新增
          </button>
          <button className="px-4 py-1.5 border border-slate-300 rounded text-sm hover:bg-slate-50 transition-colors">
            导出
          </button>
        </div>

        {/* 结果表格 */}
        <div className="overflow-x-auto border border-slate-200 rounded shadow-inner">
          <table className="w-full text-sm text-left">
            <thead className="bg-slate-50 text-slate-700 font-medium">
              <tr>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  序号
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  名称
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  类型
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  所属单位
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  状态
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  操作
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100">
              {filteredData.map((row, index) => (
                <tr key={row.id} className="hover:bg-slate-50 transition-colors">
                  <td className="p-3 whitespace-nowrap">
                    {index + 1}
                  </td>
                  <td className="p-3 whitespace-nowrap font-medium text-slate-800">
                    {row.name}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {row.type}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {row.owner}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    <span className={row.status === '启用' ? 'text-green-600' : 'text-gray-500'}>
                      {row.status}
                    </span>
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    <button className="text-blue-500 hover:text-blue-700 font-medium mr-3">
                      详情
                    </button>
                    <button className="text-blue-500 hover:text-blue-700 font-medium">
                      修改
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
